import React from 'react'
import { Button, Table, TableHead, TableRow, TableCell, TableBody, IconButton, TextField, Dialog, AppBar } from '@material-ui/core'
import { useEffect } from 'react'
import { Edit, Search, Close } from '@material-ui/icons'
import queryparse from 'querystring'
import { useHistory } from 'react-router-dom'
const TYPES = ["backgrounds", "bodies", "pants", "dresses", "faces", "eyes", "noses", "mouths", "eyebrows", "glasses", "hairs", "properties", "pets", "outers", "hats"]
export default function Gifts({ api }) {
    const [search, setSearch] = React.useState('')
    const [avatars, setAvatars] = React.useState([])
    const [count, setCount] = React.useState(0)
    const [avatarName, setAvatarName] = React.useState('')
    const [avatarImage, setAvatarImage] = React.useState('')
    const [avatarType, setAvatarType] = React.useState(0)
    const [avatarPrice, setAvatarPrice] = React.useState(1)
    const [isPublished, setPublished] = React.useState(true)
    const [avatarGender, setAvatarGender] = React.useState(1)
    const [showDialog, setShowDialog] = React.useState(false)
    const [id, setId] = React.useState('')
    const [type, setType] = React.useState(0)
    const pointer = Number(queryparse.parse(window.location.search)["?skip"] || 0)
    const history = useHistory()
    useEffect(() => {
        api.axios.get("avatars" + window.location.search)
            .then(({ count, avatars }) => {
                setCount(count)
                setAvatars(avatars);
            })
            .catch(e => console.log(e))

    }, [])
    return (
        <div>
            <Dialog open={showDialog} fullScreen={true}>
                <AppBar style={{ padding: 15 }}>Avatar {type === 0 ? 'Add' : 'Edit'}</AppBar>
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: 65, marginLeft: 10, marginRight: 10 }}>
                    <img style={{ maxHeight: 250, maxWidth: 300 }} src={`https://raw.avishekadhikari.com.np/avatars/${TYPES[avatarType]}/${avatarImage}.png`} alt="invalid-image" />
                    < br />
                    <TextField value={avatarName} onChange={e => setAvatarName(e.target.value)} variant="outlined" fullWidth label="Avatar name" />
                    <br />
                    <TextField value={avatarPrice} onChange={e => setAvatarPrice(e.target.value)} variant="outlined" fullWidth type="number" label="Avatar Price" />
                    <br />
                    <TextField value={avatarImage} onChange={e => setAvatarImage(e.target.value)} variant="outlined" fullWidth type="text" label="Avatar Image" />
                    <br />
                    <select style={{ padding: 7 }} value={avatarType} onChange={e => setAvatarType(e.target.value)}>
                        <option value="0">Background</option>
                        <option value="1">Body</option>
                        <option value="2">Pant</option>
                        <option value="3">Dress</option>
                        <option value="4">Face</option>
                        <option value="5">Eye</option>
                        <option value="6">Nose</option>
                        <option value="7">Mouth</option>
                        <option value="8">EyeBrow</option>
                        <option value="9">Glass</option>
                        <option value="10">Hair</option>
                        <option value="11">Property</option>
                        <option value="12">Pet</option>
                        <option value="13">Outer</option>
                        <option value="14">Hat</option>
                    </select>
                    <br />
                    <select style={{ padding: 7 }} value={avatarGender} onChange={e => setAvatarGender(e.target.value)}>
                        <option value="0">Male</option>
                        <option value="1">Female</option>
                        <option value="2">Both</option>
                    </select>
                    <br />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <p>Is Published?</p>
                        <input checked={isPublished} onChange={e => setPublished(e.target.checked)} style={{ margin: 10, padding: 7 }} type="checkbox" placeholder="isPublished" />
                    </div>
                    <br />
                    <div>
                        <Button
                            disabled={avatarName.trim().length === 0 || avatarPrice < 1}
                            onClick={e => {
                                api.axios.post(type === 0 ? 'avatars/add' : 'avatars/edit/' + id, {
                                    avatarType,
                                    avatarName,
                                    isPublished,
                                    avatarPrice,
                                    avatarGender,
                                    avatarImage
                                })
                                    .then(d => {
                                        api.showSnack(`Gift ${type === 0 ? 'added' : 'edited'} successfully.`, 'success')
                                        var removed = avatars.filter(x => x._id !== d._id);
                                        setAvatars([d, ...removed])
                                        setShowDialog(false)
                                    })
                                    .catch(e => api.showSnack(e.error || 'Something went wrong.'))

                            }} variant="outlined" color="primary">Save</Button>
                        &nbsp;&nbsp;
                        <Button onClick={e => setShowDialog(false)} variant="outlined" color="secondary">Cancel</Button>

                    </div>

                </div>
            </Dialog>
            <div style={{ display: 'flex', flexDirection: 'row-reverse', margin: 10 }}>
                <Button onClick={e => {
                    setType(0)
                    setShowDialog(true)
                }} variant="outlined" color="primary">Add Avatar</Button>
                &nbsp; &nbsp;
                {window.location.search !== "" && <IconButton><Close onClick={e => window.location = "?"} /></IconButton>}
                <IconButton><Search onClick={e => window.location = "?search=" + search} /></IconButton>
                <TextField value={search} onChange={e => setSearch(e.target.value)} label="Search" />

            </div>
            <Table >
                <TableHead>
                    <TableRow>
                        <TableCell>Avatar Image</TableCell>
                        <TableCell>Avatar Name</TableCell>
                        <TableCell>Avatar Price</TableCell>
                        <TableCell>Avatar Gender</TableCell>
                        <TableCell>ACTIONS</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {avatars.map(s => <TableRow key={s._id}>
                        <TableCell><img
                            style={{ maxHeight: 140, maxWidth: 300 }}
                            src={`https://raw.avishekadhikari.com.np/avatars/${s.image}.png`}
                            alt="hola" /></TableCell>
                        <TableCell>{s.name}</TableCell>
                        <TableCell>{s.price}</TableCell>
                        <TableCell>{s.gender === 0 ? 'Male' : s.gender === 1 ? 'Female' : 'Both'}</TableCell>
                        <TableCell>
                            <IconButton onClick={e => {
                                setId(s._id)
                                setAvatarName(s.name)
                                setAvatarImage(s.image.split("/").pop())
                                setAvatarType(s.type)
                                setAvatarPrice(s.price)
                                setAvatarGender(s.gender)
                                setShowDialog(true)
                                setType(1)
                                setPublished(s.isPublished)
                            }}><Edit /></IconButton>
                        </TableCell>

                    </TableRow>)}
                </TableBody>
                <div style={{ margin: 10, display: 'flex', justifyContent: 'center' }}>
                    {pointer > 19 && <Button onClick={e => window.location = ("?skip=" + (pointer - 20))}>Previous Page</Button>}
                    {pointer + 20 < count && <Button onClick={e => window.location = ("?skip=" + (pointer + 20))}> Next Page</Button>}
                </div>
            </Table>
        </div >
    )
}
